export default "__VITE_ASSET__CS$Us3fu__"